<div class="assignmentGroupPanelList">
  <app-panel-list *ngIf="!showLoader && panelListFetched"
  [showLoader] = "showPanelLoader"
    [panelList]="assignmentGroupPanelListInformation"
    [noResultFound]="!isPanelListDataAvailable"
    [ifAdditionalItems]="true"
  >
  <span class="additional-items">
    <p-checkbox   
    class="col p-0 pr-2"
    name="showInactiveDelegates"
    value="all"
    [(ngModel)]="isInActiveSelected"
    [binary]="true"
    (onChange)="checkboxSelection($event)"
    ></p-checkbox>
  <app-label labelText="Show Inactive"></app-label>
  </span>
    <ng-template #templateRef let-data="dataVar">
      <div panel-content class="grid assignmentGroupPanelCards">
        <div class="col-3 text-left">
          <app-label labelText="{{ 'Name' }}"></app-label>
          <app-read-only readonlyText="{{ data?.name }}"></app-read-only>
        </div>
        <div class="col-3 text-left">
          <app-label labelText="{{ 'Description' }}"></app-label>
          <div class="font-semibold text-wrapper" readonly="readonly" pTooltip="{{data?.description}}" tooltipPosition="{{'top'}}">
            {{data?.description}}
        </div>
        </div>
        <div class="col-2 text-left">
          <app-label labelText="{{ 'Assignment' }}"></app-label>
          <app-read-only readonlyText="{{ data?.assignmentName }}"></app-read-only>
        </div>
        <div class="col-2 text-left" *ngIf="assignmentGroupPanelListInformation.enableToggling"  > 
          
          <app-label labelText="{{ 'Users' }}"></app-label>
          <!-- When collapsed: Show only the first user with '...' -->
          <app-read-only *ngIf="data?.users.length > 0" readonlyText="{{ data?.users[0].assignedUserName }}"
            [ngClass]="{'inActiveGroup': data?.users[0].isActive === false || data?.users[0].isTerminated === true}"
            toolTipMessage="{{ getAllUserNames(data?.users) }}"></app-read-only>
          <span class="display-inline" *ngIf="data?.users.length > 1 && data.collapsed">&#8230;</span>
        </div>
        <div class="col text-left">
          <app-label labelText="{{ 'Is Active' }}"></app-label>
          <div class="mt-1">
            <em
              class="pi pi-circle-fill"
              [ngClass]="{
                active: data?.isActiveValue == 'Yes',
                inactive: data?.isActiveValue == 'No'
                }"
            ></em>
            {{ data?.isActiveValue }}
          </div>
        </div>
        <div class="col text-left">
          <app-speed-dial [menuItemsData]="setActions(data)"> </app-speed-dial>
        </div>
      </div>
    </ng-template>
    <ng-template #templateRef let-data="dataVar">
      <div panel-content class="grid assignmentGroupPanelAfterTogglingCards">
        <div class="col-3 text-left padding-top-0">
        </div>
        <div class="col-3 text-left padding-top-0">
        </div>  
        <div class="col-2 text-left padding-top-0">
        </div>
        <div class="col-2 text-left padding-top-0">
            <div *ngFor="let user of data?.users.slice(1), let i=index">
            <app-read-only [ngClass]="{'inActiveGroup':user.isActive===false || user.isTerminated === true}" readonlyText="{{ user.assignedUserName }}" toolTipMessage="{{ user.assignedUserName }}"></app-read-only>
          </div>
        </div>
        <div class="col text-left padding-top-0"></div>
        <div class="col text-left padding-top-0"></div>
      </div>
    </ng-template>
  </app-panel-list>
</div>

